import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useMemo, type ReactNode } from "react";
export type LinkPreviewVariant = "chat" | "home";
type LinkPreviewContextValue = {
  readonly variant: LinkPreviewVariant;
  readonly hideActions: boolean;
};
const DEFAULT_CONTEXT: LinkPreviewContextValue = {
  variant: "chat",
  hideActions: false
};
const LinkPreviewContext = createContext<LinkPreviewContextValue>(DEFAULT_CONTEXT);
export const LinkPreviewProvider = t0 => {
  const $ = _c(6);
  const {
    variant: t1,
    children
  } = t0;
  const variant = t1 === undefined ? "chat" : t1;
  const t2 = variant === "home";
  let t3;
  if ($[0] !== t2 || $[1] !== variant) {
    t3 = {
      variant,
      hideActions: t2
    };
    $[0] = t2;
    $[1] = variant;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const value = t3;
  let t4;
  if ($[3] !== children || $[4] !== value) {
    t4 = <LinkPreviewContext.Provider value={value}>{children}</LinkPreviewContext.Provider>;
    $[3] = children;
    $[4] = value;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export const useLinkPreviewContext = () => {
  return useContext(LinkPreviewContext);
};
export const useLinkPreviewVariant = () => {
  return useLinkPreviewContext().variant;
};